<script>
import {
    Block,
    BlockTitle,
    Link,
    Tabs,
    Tab
} from 'framework7-svelte';
import { onMount } from 'svelte';
onMount(() => {

})
</script>
<style>

</style>

<Block strong mediumInset style="text-align: justify;">
    <p>
        La CONABIO agradece a todas las personas e instituciones que han apoyado y colaborado en la realización del Sistema de Alerta Temprana de Incendios Forestales (SATIF)
    </p>
    <p>
        El tema se inició con el apoyo de USAID (The United Sates Agency for International Development) a través del del Fondo Mexicano para la Conservación de la Naturaleza (FMCN), así como de la NOAA-NGDC National Oceanic & Atmospheric Administration - National Geophysical Data Center, institución que facilitó las primeras imágenes de satélite utilizadas en la detección de los puntos de calor en 1998.
    </p>
    <p>
        La nueva versión 2021 de la página web del SATIF fue desarrollada gracias al apoyo del Servicio Forestal de los Estados Unidos de Norte América – Programa México.
    </p>
    <p>
        El sistema no sería posible sin la continua e invaluable ayuda de muchas instituciones nacionales e internacionales, entre ella:
    </p>

    <p>Además, en la sección Información disponible se especifica la forma de citar para cada producto.</p>
</Block>
<BlockTitle> NACIONALES </BlockTitle>
<Block strong mediumInset style="text-align: justify;">
    <ul>
        <li><p>Centro Nacional de Prevención de Desastres (CENAPRED)</p></li>
        <li><p>Comisión Nacional Forestal (CONAFOR)</p></li>
        <li><p>Comisión de Áreas Naturales Protegidas (CONANP)</p></li>
        <li><p>Consejo Nacional para la Ciencia y Tecnología (CONACYT)</p></li>
        <li><p>Fondo Mexicano para la Conservación de la Naturaleza (FMCN)</p></li>
        <li><p>Fondo para Desastres Naturales (FONDEN)</p></li>
        <li><p>Fondo para la Prevención de Desastres Naturales (FOPREDEN)</p></li>
        <li><p>Instituto de Geografía de la Universidad Nacional Autónoma de México (UNAM)</p></li>
        <li><p>Procuraduría Federal de Protección al Ambiente (PROFEPA)</p></li>
        <li><p>Secretaría de Medio Ambiente y Recursos Naturales (SEMARNAT)</p></li>
        <li><p>Universidad Juárez del Estado de Durango (UJED)</p></li>
    </ul>
</Block>
<BlockTitle> INTERNACIONALES </BlockTitle>
<Block strong mediumInset style="text-align: justify;">
    <ul>
        <li><p>Centrum für Internationale Migration und Entwicklung</p></li>
        <li><p>Community Satellite Processing Package (CSPP)</p></li>
        <li><p>The United States Agency for International Development (USAID)</p></li>
        <li><p>Instituto Nacional de Pesquisas Espaciales (INPE)</p></li>
        <li><p>National Aeronautics and Space Administration (NASA)</p></li>
        <li><p>NASA Direct Redout Lab</p></li>
        <li><p>National Oceanic & Atmospheric Administration (NOAA)</p></li>
        <li><p>Servicio Forestal de los Estados Unidos de Norte América – Programa México</p></li>
    </ul>
</Block>
